const dataRangeList = [
  'current',
  'last 1',
  'last 3',
  'last 6',
  'last 9',
  'last 12',
  'last 13',
  'last 14',
  'last 18',
];

export default dataRangeList;
